import { Pipe, PipeTransform } from '@angular/core';
import { RunTicket } from '../../../app/_models/field';
import { ListsHelperService } from '../_services/lists-helper.service';

@Pipe({ name: 'ticketSortBy' })

export class TicketSortByPipe implements PipeTransform {
  constructor(private listHelper: ListsHelperService) { }

  transform(runTickets: RunTicket[], column: string, desc: boolean): any[] {
    if (!runTickets || runTickets.length == 0) return [];
    if (!column) return runTickets;
    if (desc == null) {
      desc = true;
    }
    switch (column) {
      case 'battery': {
        runTickets.sort(this.listHelper.sortSubPropertyString(column, 'batteryName', desc));
        break;
      }
      case 'tank': {
        runTickets.sort(this.listHelper.sortSubPropertyString(column, 'tankName', desc));
        break;
      }
      default: {
        runTickets.sort(this.listHelper.sortProperty(column, desc));
        break;
      }
    }

    return runTickets;
  }
}
